export enum SubscriptionType {
    All = 'ALL',
    Alerts = 'ALERTS',
    None = 'NONE',
}
